/**
 * Which workspace this window shows. Every build shows the wall; the old
 * canvas is no longer offered (Settings no longer has "Use the old canvas").
 * The renderer and every open path still follow `preferred` alone (Part 06
 * decisions 6 and 9), so the old canvas code stays reachable from tests. It is
 * kept on purpose: it may come back as a planning canvas (setting up work,
 * forking conversations), not as the place frames are shown.
 */
import { create } from "zustand";

export type WorkspaceView = "wall" | "canvas";

interface WorkspaceViewState {
  preferred: WorkspaceView;
}

export const useWorkspaceViewStore = create<WorkspaceViewState>()(() => ({
  preferred: "wall",
}));

/** True when this window's workspace is the wall. */
export function isWallActive(): boolean {
  return useWorkspaceViewStore.getState().preferred === "wall";
}
